import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ToastModule } from 'primeng/toast';

@Component({
	imports: [RouterModule, ConfirmPopupModule, ToastModule],
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrl: './app.component.scss',
})
export class AppComponent {
	constructor(private readonly translate: TranslateService) {
		this.translate.addLangs(['en', 'sr']);
		this.translate.setDefaultLang('sr');
		this.translate.use('sr');
	}
}
